import{ADD_CHECKOUT_CAMPAIGN}from"../constants/actionTypes";/**
 * Creates the dispatched ADD_CHECKOUT_CAMPAIGN action object.
 * @param {Object} data The campaign data
 * @returns {Object} The dispatched action object.
 */export var addCheckoutCampaign=function addCheckoutCampaign(){var data=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{type:ADD_CHECKOUT_CAMPAIGN,data:data};};